































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../../RestClient";
import DateFormatter from "../../../shared/DateFormatter";
import Loading from "../../general/Loading.vue";

import RentalRequestBooking from "./RentalRequestBooking.vue";
import { getRentalConditionPrice } from "../../../shared/RentalConditionJson";

import { SettingsPublicJson } from "../../../shared/SettingsJson";
import RentalBookingInfoJson from "../../../shared/RentalBookingInfoJson";
import ClientJson from "../../../shared/ClientJson";
import RentalBookingJson from "../../../shared/RentalBookingJson";
import TableView, { TableViewColumnDefinitions } from "../../controls/TableView.vue";

import GeneralInfos from "../../custom/GeneralInfos";

export default Vue.extend({
  name: "RentalCart",
  components: {
    Loading,
    TableView,
    RentalRequestBooking,
  },
  props: {
    appFrameClickedButton: Object,
    settings: Object as PropType<SettingsPublicJson | null>,
    rentalBookingInfo: Object as PropType<RentalBookingInfoJson | null>,
    clientData: Object as PropType<ClientJson>,
    clientPassword: String,
    restrictToTypeId: Number as PropType<number | null>,
    rentalCart: Array as PropType<RentalBookingJson[]>,
  },
  data() {
    return {
      RestClient: RestClient,
      DateFormatter: DateFormatter,
      GeneralInfos: GeneralInfos,
      getRentalConditionPrice: getRentalConditionPrice,
      bookings: null as RentalBookingJson[] | null,
      showRequestBooking: false as boolean,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", {
      overview: true,
      account: true,
      cart: true,
    });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showRequestBooking = !this.showRequestBooking;
      if (this.showRequestBooking == false) {
        //this.reloadData()
      }
    },

    openDetails(item: any | null) {
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllBookings();
    },

    async loadAllBookings() {
      this.bookings = null;

      this.bookings = this.rentalCart;
    },

    async reloadData() {
      this.loadAllBookings();
    },

    deleteItem(index: number) {
      if (this.bookings != null) {
        this.bookings.splice(index, 1);
      }
    },

    //tableView
    tableViewButtonClicked(button: string, item: any, index: number) {
      if (button == "deleteItem") {
        this.deleteItem(index);
      }
    },

    tableViewItemClicked(item: any, index: number) {},

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    rentalCart() {
      this.bookings = this.rentalCart;
    },
  },
  computed: {
    bookingColumns: function (): TableViewColumnDefinitions<RentalBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Produkt",
          td: (i) => i.rentalItem?.name,
        },
        {
          th: "Anzahl",
          td: (i) => i.amount,
        },
        {
          th: "Zeitraum",
          td: (i) =>
            vue.DateFormatter.formatWeekdayDate(new Date(i.beginDate)) +
            " – " +
            vue.DateFormatter.formatWeekdayDate(new Date(i.endDate)),
        },
        {
          th: "Preiskategorie",
          td: (i) => i.rentalCondition?.title + " | " + vue.getFormatPrice(i.rentalCondition?.price) + " €",
        },
        {
          th: "Einzelpreis",
          td: (i) =>
            "€ " +
            vue.getFormatPrice(
              vue.getRentalConditionPrice(i.rentalCondition, 1, new Date(i.beginDate), new Date(i.endDate))
            ),
        },
        {
          th: "Preis",
          td: (i) =>
            "€ " +
            vue.getFormatPrice(
              vue.getRentalConditionPrice(i.rentalCondition, i.amount, new Date(i.beginDate), new Date(i.endDate))
            ),
        },
        {
          th: "",
          td: (i) => "Entfernen",
          style: (i) => "text-align:right",
          button: "deleteItem",
        },
      ] as TableViewColumnDefinitions<RentalBookingJson>[];
    },
  },
});
